module.exports = __webpack_public_path__ + "img/feature_safe.e235aea5.png";